import getURLParams from 'utils/DOM/getURLParams'
import objectToUrl from 'utils/DOM/objectToUrl'

function addParametersToLink(search, parameters) {
  const params = getURLParams(search)

  for (const key in parameters) {
    params[key] = parameters[key]
  }

  const result = objectToUrl(params)

  return result ? '?' + result : ''
}

export default addParametersToLink
